import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Video, Code2, ArrowRight } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Realisations = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <Header />

      <main className="pt-16">
        <section className="py-20 bg-gradient-to-b from-slate-900 to-black">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <Link
                to="/"
                className="inline-flex items-center space-x-2 text-gray-400 hover:text-white mb-8 transition-colors"
              >
                <ArrowLeft className="h-4 w-4" />
                <span>Retour à l'accueil</span>
              </Link>

              <h1 className="text-4xl lg:text-6xl font-bold mb-6 tracking-tight text-white">
                Réalisations
              </h1>
              <div className="w-16 h-1 rounded-full mx-auto mb-8" style={{ backgroundColor: '#f97316' }}></div>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
                Choisissez le type de réalisations que vous souhaitez découvrir.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8">
              <Link
                to="/realisations/web"
                className="group relative rounded-2xl p-8 sm:p-10 border border-orange-500/40 bg-slate-900/70 hover:bg-slate-900/90 transition-all duration-300 overflow-hidden shadow-xl shadow-orange-500/10"
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute inset-0 bg-gradient-to-br from-blue-500/10 via-transparent to-transparent"></div>
                </div>
                <div className="relative">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="h-11 w-11 rounded-full flex items-center justify-center bg-blue-600">
                      <Code2 className="h-5 w-5 text-white" />
                    </div>
                    <span className="text-sm uppercase tracking-[0.2em] text-orange-300">Web</span>
                  </div>
                  <h3 className="text-2xl font-semibold text-white mb-3">
                    Sites & e-commerce
                  </h3>
                  <p className="text-gray-300 mb-6">
                    Projets web conçus pour convertir et performer.
                  </p>
                  <div className="flex items-center gap-2 text-white font-medium">
                    Voir les sites réalisés
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>

              <Link
                to="/realisations/video"
                className="group relative rounded-2xl p-8 sm:p-10 border border-slate-800 bg-slate-900/60 hover:bg-slate-900/80 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 via-transparent to-transparent"></div>
                </div>
                <div className="relative">
                  <div className="flex items-center gap-3 mb-6">
                    <div className="h-11 w-11 rounded-full flex items-center justify-center" style={{ backgroundColor: '#f97316' }}>
                      <Video className="h-5 w-5 text-white" />
                    </div>
                    <span className="text-sm uppercase tracking-[0.2em] text-gray-400">Vidéo</span>
                  </div>
                  <h3 className="text-2xl font-semibold text-white mb-3">
                    Films & productions
                  </h3>
                  <p className="text-gray-300 mb-6">
                    Mariages, corporate, drone & projets sportifs.
                  </p>
                  <div className="flex items-center gap-2 text-white font-medium">
                    Voir les réalisations vidéo
                    <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Realisations;
